export const tourGuideSteps = [
  {
    selector: "#previous-version-card",
    content:
      "Click on the link to get information for docker images prior to 4.6.",
  },
  {
    selector: "#auth-mcc-repo-card",
    content:
      "This is the information required to authenticate with the MCC Docker Repository in order to pull a Docker image.",
  },
  {
    selector: "#auth-token-button",
    content:
      "Click the button to generate a security token valid for 12 hours.",
  },
  {
    selector: "#sample-docker-login-command-card",
    content:
      "Use this command to login to the MCC Docker Repository. Click the copy button to add the command to your clipboard.",
  },
  {
    selector: "#pull-docker-image-card",
    content:
      "This is the list of all available artifacts in the MCC Docker Repository. As you select a object the Docker Pull Command is generated for you below. You can click the copy icon to add the Docker Pull Command to your clipboard.",
  },
  {
    selector: "#docker-pull-command-card",
    content:
      "Once a docker image is selected above, the docker pull command will be generated.  The pull command can be copied to the clipboard by pressing the copy button on the right.",
  },
];
